import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from 'sonner';
import Auth from './pages/Auth';
import Register from './pages/Register';
import '@/App.css';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Matters = lazy(() => import('./pages/Matters'));
const MatterDetail = lazy(() => import('./pages/MatterDetail'));
const DocumentViewer = lazy(() => import('./pages/DocumentViewer'));
const Chat = lazy(() => import('./pages/Chat'));
const Billing = lazy(() => import('./pages/Billing'));
const Subscribe = lazy(() => import('./pages/Subscribe'));
const Settings = lazy(() => import('./pages/Settings'));

const PageLoader = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#FEFDFB',
    fontFamily: 'Inter, sans-serif',
    color: '#6B7280'
  }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{
        width: 32, height: 32, margin: '0 auto 12px',
        border: '3px solid #E5E7EB',
        borderTopColor: '#B35309',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }} />
      <p style={{ fontSize: 14 }}>Loading...</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { token } = useAuth();
  return token ? children : <Navigate to="/auth" replace />;
};

const PublicRoute = ({ children }) => {
  const { token } = useAuth();
  return !token ? children : <Navigate to="/app/matters" replace />;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Navigate to="/auth" replace />} />
              <Route path="/auth" element={<PublicRoute><Auth /></PublicRoute>} />
              <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
              <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}>
                <Route index element={<Navigate to="/app/matters" replace />} />
                <Route path="matters" element={<Matters />} />
                <Route path="matters/:matterId" element={<MatterDetail />} />
                <Route path="documents/:documentId" element={<DocumentViewer />} />
                <Route path="chat/:matterId" element={<Chat />} />
                <Route path="billing" element={<Billing />} />
                <Route path="subscribe" element={<Subscribe />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster position="top-right" richColors expand={true} />
      </div>
    </AuthProvider>
  );
}

export default App;
